module.exports = __webpack_public_path__ + "static/kirifont-webfont-628cce2d84d522dbe0f655a0543514b0.woff";